export const ROOT = '/';
export const APP = '/app';

/**
 * AUTH ROUTES
 */
export const LOGIN = '/';
export const FORGOT_PASSWORD = '/forgot-password';
export const RESET_PASSWORD = '/reset-password/:token';
export const LOGOUT = '/logout';

/**
 * CBX (MAIN LAYOUT ENTRY)
 */
export const CBX = '/cbx';

/**
 * CBX MODULE ROUTES
 */
export const CBX_CUSTOMER_MANAGEMENT = `${APP}${CBX}/customer-management`;
export const CBX_REPORTS = `${APP}${CBX}/reports`;
export const CBX_VISITOR_LOGS = `${APP}${CBX}/load-visitor-logs`;
export const CBX_PROFILE = `${APP}${CBX}/profile`;
